import { FC } from "react";
import "./styles.scss";

const NoResult: FC = () => (
  <div className="no-result">
    <img src='../images/noResult.jpg' alt="noResult" width={200} />
    <div>Oops, there are no vans for this search.</div>
    <div>Try to change the <b>End</b> location.</div>
    <div>Clear all filters & change your dates.</div>
    <div>
      You can request a manual quote
      <a href="https://sprinter-rentals.com/reserve-sprinter-van-online">
        here
      </a>
    </div>
  </div>
);
export default NoResult;
